import { faPhone, faTv, faWifi, faEthernet } from '@fortawesome/pro-regular-svg-icons'
import { faHdd } from '@fortawesome/free-regular-svg-icons'
import { faSensor, faIntercom, faDesktop, faSpeaker  } from 'helpers/customIcons'

export default (type, asIcon = false) => {
  switch (type) {
    case 'Environmental / Vape Sensor':
      return asIcon ? faSensor.icon : ['fac', 'sensor']
    case 'Intercom':
      return asIcon ? faIntercom.icon : ['fac', 'intercom']
    case 'PC / Workstation':
      return asIcon ? faDesktop.icon : ['fac', 'desktop']
    case 'Phone':
      return asIcon ? faPhone.icon : ['far', 'phone']
    case 'Public View Monitor / TV':
      return asIcon ? faTv.icon : ['far', 'tv']
    case 'Recorder':
      return asIcon ? faHdd.icon : ['far', 'hdd']
    case 'Speaker / Horn':
      return asIcon ? faSpeaker.icon : ['fac', 'speaker']
    case 'Wireless Access Point':
      return asIcon ? faWifi.icon : ['far', 'wifi']
    case 'Cable Drop':
    default:
      return asIcon ? faEthernet.icon : ['far', 'ethernet']
  }
}



// WEBPACK FOOTER //
// ./src/helpers/wiredDevices/getTypeIconString.js